const noop = () => {}

export function getFilename(url) {
  let filename
  try {
    filename = new URL(url, 'https://example.com').pathname.split('/').pop()
  } catch (error) {
    console.error(error)
  }

  if (filename) {
    return filename
  }
}

export const getImageAlt = (
  { url, alt } = {},
  i18n = { __: noop, sprintf: noop }
) => {
  const filename = getFilename(url)
  let defaultedAlt

  if (alt) {
    defaultedAlt = alt
  } else if (filename) {
    defaultedAlt = i18n.sprintf(
      /* translators: %s: file name */
      i18n.__(
        'This image has an empty alt attribute; its file name is %s',
        'jgu-base'
      ),
      filename
    )
  } else {
    defaultedAlt = i18n.__('This image has an empty alt attribute', 'jgu-base')
  }

  return defaultedAlt
}

export const sanitizeString = str => {
  // eslint-disable-next-line
  str = str.replace(/([^a-z0-9áéíóúñü_-\s,]|[\t\n\f\r\v\0])/gim, '')
  return str.trim().toLowerCase().split(' ').join('-')
}

export const preparePhoneLink = val => {
  if (val != undefined) {
    return 'tel:' + val.replace(/[^+\d]+/g, '')
  }
}

export const maybeCssVariable = (color = '') => {
  const matches = color.match(/.*var\(.*--(?:clr-)?([\w-]+).*\).*/i)
  return matches ? matches[1] : color
}

export const getLangCode = () => {
  let langCode = 'de'
  const langAttr = document
    .getElementsByTagName('html')[0]
    .getAttribute('lang')
    .toLowerCase()

  if (langAttr) {
    if (langAttr === 'de-ch') {
      langCode = langAttr
    } else {
      langCode = langAttr.split('-')[0]
    }
  }

  return langCode
}

export const getLangCodeByCookie = () => {
  const regex = new RegExp('(^| )wp-wpml_current_language=([^;]+)')
  const match = document.cookie.match(regex)
  if (match) {
    return match[2]
  }
  return ''
}

export const getCorrectColorClassName = (color = '') => {
  switch (color) {
    case 'var(--light-primary)':
      return 'primary'
    case 'var(--primary)':
      return 'dark-primary'
    case 'var(--light-secondary)':
      return 'secondary'
    case 'var(--secondary)':
      return 'dark-secondary'
    case 'var(--light-tertiary)':
      return 'tertiary'
    case 'var(--tertiary)':
      return 'dark-tertiary'
    case 'var(--light-orange)':
      return 'orange'
    default:
      return color
  }
}
